module.exports = __webpack_public_path__ + "media/homeProperty/propertyImage-51f9565c.png";